import type { MouseEvent, ReactNode } from 'react';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const popIn = keyframes`
  from { opacity: 0; transform: scale(0.96); }
  to { opacity: 1; transform: scale(1); }
`;

export const Backdrop = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  animation: ${fadeIn} 0.3s ease forwards;
`;

export const PopupWrapper = styled.div<{ children: ReactNode }>`
  position: relative;
  z-index: 1;
  width: 90%;
  max-width: 480px;
  max-height: 90vh;
  overflow-x: hidden;
  overflow-y: auto;
  background: white;
  border-radius: 16px;
  padding: 40px 24px 24px;
  animation: ${popIn} 0.3s ease forwards;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);

  h1,
  h2 {
    margin-top: 0;
  }
`;

export const CloseButton = styled.button<{
  'aria-label': string;
  children: string;
  onClick: (e: MouseEvent) => void;
}>`
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #fff;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 0.9rem;
  line-height: 1;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }
`;
